import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";
import { SignIn } from "@phosphor-icons/react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("maxine_admin_token", r.data.token);
      localStorage.setItem("maxine_admin_user", JSON.stringify(r.data.user));
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-[color:var(--paper-alt)] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white border border-[color:var(--line)] p-8 md:p-10">
        <img src="/logo-maxine.png" alt="Maxine Consulting OPC Private Limited" className="h-10 w-auto" />
        <h1 className="mt-6 font-display font-black text-3xl">Admin sign in</h1>
        <p className="mt-2 text-sm text-neutral-600">Manage content, leads, blog and pricing.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">Email</label>
            <input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="mt-1 w-full border border-[color:var(--line)] focus:border-[color:var(--brand)] outline-none px-4 py-3"
            />
          </div>
          <div>
            <label className="font-mono text-[10px] uppercase tracking-widest text-neutral-500">Password</label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="mt-1 w-full border border-[color:var(--line)] focus:border-[color:var(--brand)] outline-none px-4 py-3"
            />
          </div>
          <button data-testid="admin-signin-btn" disabled={loading} className="btn-brand w-full justify-center">
            <SignIn size={16} weight="bold" /> {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <a href="/" className="mt-6 block text-center text-xs font-mono uppercase tracking-widest text-neutral-500 hover:text-[color:var(--brand)]">← Back to site</a>
      </div>
    </div>
  );
}
